export const CompetitorDeepDive = ({ competitors = [] }) => {
  if (!competitors.length) {
    return <p className="text-sm text-slate-500" data-testid="competitor-deep-dive-empty">No competitor mentions detected across AI models yet.</p>;
  }
  return (
    <div className="space-y-3" data-testid="competitor-deep-dive">
      {competitors.map((c, i) => (
        <div key={i} className="flex min-w-0 items-center gap-3" data-testid={`competitor-row-${i}`}>
          <span className="w-24 flex-shrink-0 truncate text-sm text-slate-300">{c.name}</span>
          <div className="h-2 min-w-0 flex-1 overflow-hidden rounded-full bg-surface-border">
            <div className="h-full rounded-full bg-claude-purple" style={{ width: `${c.share_of_voice || 0}%` }} />
          </div>
          <span className="w-10 flex-shrink-0 text-right text-xs text-slate-500">{c.share_of_voice || 0}%</span>
        </div>
      ))}
    </div>
  );
};
